export enum Direction {
  PREV = 'PREV',
  NEXT = 'NEXT',
}
